import { render, staticRenderFns } from "./UiTokenConfirm.vue?vue&type=template&id=e1137278&lang=pug&"
import script from "./UiTokenConfirm.vue?vue&type=script&lang=js&"
export * from "./UiTokenConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports